<template>
  <section class="container py-3" v-if="reward">
    <div class="row">
      <div class="col-12 col-lg-6 offset-lg-3">
        <div class="py-3">
          <router-link to="/rewards" class="text-primary-link">
            {{ $t('message.rewards.title') }}
          </router-link>
          <i class="fal fa-angle-right"></i>
          {{ $t('message.rewards.detail') }}
        </div>

        <img :src="reward.image_url" class="img-fluid rounded">
        <div class="my-4">
          <h3 class="text-center">{{ ($i18n.locale === 'th') ? reward.title_th : reward.title_en }}</h3>
        </div>
        <div class="d-flex">
          <div class="flex-fill">
            <div>{{ $t('message.rewards.points') }}</div>
            <h4 class="d-inline-block text-info">{{ reward.points | prettyNumber }}</h4>
            <span class="text-secondary text-small">{{ $t('message.rewards.points') }}</span>
          </div>
          <div class="mx-3" style="width: 1px; height: 40px; background-color: #E0E0E0;"></div>
          <div class="flex-fill">
            <div>{{ $t('message.rewards.redeem_by') }}</div>
            <h4 class="d-inline-block">{{ reward.end_date | prettyOnlyDate }}</h4>
          </div>
        </div>
        <hr>
        <div class="pt-2">
          <!-- <div v-html="($i18n.locale === 'th') ? reward.content_th : reward.content_en"></div> -->
          <div v-html="handleNewLine(($i18n.locale === 'th') ? reward.content_th : reward.content_en )"></div>
        </div>
        <div class="py-3" v-if="user">
          <button class="btn btn-info btn-block" :disabled="!canRedeem()" @click="displayConfirmDialog()">
            {{ $t('message.button.redeem') }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex'
  import axios from 'axios'

  export default {
    data () {
      return {
        rewardId: this.$route.params.id
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('reward', ['reward'])
    },
    methods: {
      ...mapActions('reward', ['fetchRewardDetail']),
      handleNewLine (str) {
        return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
      },
      displayConfirmDialog () {
        this.$swal({
          text: this.$i18n.t('message.rewards.dialog_confirm_message'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.button.confirm'),
          cancelButtonText: this.$i18n.t('message.button.cancel')
        }).then(() => {
          this.redeemRewards()
        })
      },
      displaySuccessDialog (userReward) {
        const title = this.$i18n.t('message.rewards.redeem_successful_title')
        this.$swal({
          title: title,
          type: 'success',
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonColor: '#17a2b8',
          confirmButtonText: this.$i18n.t('message.rewards.view_my_rewards')
        }).then((result) => {
          if (result) {
            this.$router.push(`/user-rewards/${userReward.id}`)
          }
        })
      },
      async redeemRewards () {
        const url = 'user-points/redeem-rewards'
        const submitData = {
          user_id: this.user.id,
          reward_id: this.rewardId
        }
        let {data} = await axios.post(url, submitData)
        if (!data.error) {
          const userReward = data.user_reward
          if (userReward.reward.delivery_info_type) {
            this.$router.push(`/user-rewards/${userReward.id}/delivery-info`)
          } else {
            this.displaySuccessDialog(userReward)
          }
        } else {
          let errorMessage = data.message
          switch (data.error_code) {
            case 'insufficient_points':
              errorMessage = this.$i18n.t('message.rewards.error_insufficient_points')
              break
            case 'expired_reward':
              errorMessage = this.$i18n.t('message.rewards.error_expired_reward')
              break
            case 'expired_points':
              errorMessage = this.$i18n.t('message.rewards.error_expired_points')
              break
            case 'empty_reward':
              errorMessage = this.$i18n.t('message.rewards.error_empty_reward')
              break
            case 'insufficient_balance':
              errorMessage = this.$i18n.t('message.rewards.error_insufficient_balance')
              break
          }
          this.$swal({text: errorMessage, type: 'error'})
        }
      },
      canRedeem () {
        let canRedeem = true
        if (this.reward) {
          const today = new Date()
          const expireDate = new Date(`${this.reward.end_date} 23:59:59`)
          const isExpired = today > expireDate
          if (isExpired) {
            canRedeem = false
          } else if (this.reward.type === 'voucher' && this.reward.remaining_count <= 0) {
            canRedeem = false
          }
        }
        return canRedeem
      }
    },
    mounted () {
      this.fetchRewardDetail(this.rewardId)
    }
  }
</script>


<style scoped>
  div >>> ol {
    padding-left: 1.25rem !important;
  }
  div >>> ul {
    padding-left: 1.25rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reward/RewardDetail.vue